export default __webpack_public_path__ + "static/media/invoicevector.4beed7e3.png";